import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ForgotPasswordEmailForm from './forgotpasswordemailForm';
import ResetPasswordForm from './resetpasswordForm';
import {sendTemporaryPassword, resetPassword} from '../../actions/user.actions';
import { pageViewEvent } from '../../helpers/general.helper';
import { Helmet } from 'react-helmet';

class ForgotPassword extends Component{
    constructor(props){
        super(props);
        this.state = {
            submited: false,
            email: ''
        }
    }

    componentWillMount(){
        window.scrollTo(0, 0);
    }
    
    componentDidMount() {
        pageViewEvent('Resetare parola - Cinemap',window.location.href);
     }

    resetPassword = (data) => {
        const payload = {
            name: data.email,
            temp_pass: data.tempPassword,
            new_pass: data.password
        }
        this.props.resetPassword(payload);
    }

    sendTemporaryPassword = (data) => {
        const payload = {
            mail: data.email
        }
        this.props.sendTemporaryPassword(payload);
        this.setState({submited: true, email:data.email});
    } 

    render() {
        return (
            <Fragment>
                <Helmet>
                    <title>Resetare parola - Cinemap</title>
                    <meta name="description" content="Ți-ai uitat parolă? Introduceţi adresa de email pentru generarea parolei temporare."/>
                    <link rel='canonical' href={window.location.href}/>
                </Helmet>
                {this.state.submited ? 
                    <ResetPasswordForm 
                        onSubmit={this.resetPassword}
                        email={this.state.email} />: 
                    <Fragment>
                        <ForgotPasswordEmailForm onSubmit={this.sendTemporaryPassword} />
                    </Fragment>
                }             
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
})

export default connect(mapStateToProps,{sendTemporaryPassword, resetPassword})(ForgotPassword);


// WEBPACK FOOTER //
// ./src/SHARED/components/forgotpassword/forgotpassword.component.js